import axios from 'axios'
import authHeader from './auth-header'

class CollaboratorImportService {
  downloadTemplate () {
    return axios.get(
      process.env.VUE_APP_API_URL + 'collaborator-imports/template',
      { headers: authHeader(), responseType: 'blob' }
    )
  }

  analyze (file, platforms) {
    const data = new FormData()
    data.append('file', file)
    platforms.forEach(platform => data.append('platforms[]', platform))
    return axios.post(
      process.env.VUE_APP_API_URL + 'collaborator-imports/analyze',
      data,
      { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }, timeout: 30000 }
    )
  }

  get (uuid) {
    return axios.get(
      process.env.VUE_APP_API_URL + `collaborator-imports/${uuid}`,
      { headers: authHeader(), timeout: 30000 }
    )
  }

  execute (uuid, payload) {
    return axios.post(
      process.env.VUE_APP_API_URL + `collaborator-imports/${uuid}/execute`,
      payload,
      { headers: authHeader(), timeout: 30000 }
    )
  }
}

export default new CollaboratorImportService()
